// Mock data for All-In Radio clone (modern version)
// NOTE: This data is MOCKED for the frontend draft.

export const STATION = {
  name: "All-In Radio",
  tagline: "Het Radionieuws",
  slogan: "",
  logo: "/allin-logo-white.png",
  logoFull: "/allin-logo-white.png",
  // Original stream source discovered from the site's radio-player plugin config.
  streamUrl: "http://media2.hostin.cc/allinradio.mp3",
  license: "81275473",
};

export const PROGRAMS = [
  {
    id: "muziekmarathon",
    schedule: "Maandag t/m vrijdag · 09:00 – 17:00",
    name: "De Muziekmarathon!",
    desc: "All-In werkt met je mee met een verrassende en verfrissende muziekmix voor je werkdag!",
    icon: "Music",
  },
  {
    id: "all12inch",
    schedule: "Vrijdag · 20:00 – 00:00",
    name: "All-12-Inch!",
    desc: "Uitsluitend 12-inch en extended versions van de beste classics!",
    icon: "Disc3",
  },
  {
    id: "partyclassics",
    schedule: "Zaterdag · 20:00 – 00:00",
    name: "De Partyclassics!",
    desc: "Dansbare RETRO-kneiters uit de 90's en 00's!",
    icon: "PartyPopper",
  },
  {
    id: "ongehoordgoed",
    schedule: "Zondag · 20:00 – 00:00",
    name: "Ongehoord goed!",
    desc: "Laat je verrassen door vervlogen plaatjes die te weinig op de radio worden gedraaid!",
    icon: "Sparkles",
  },
];

export const NOW_PLAYING = {
  title: "All-In Radio - Het Radionieuws",
  artist: "Live uitzending",
};

export const SCHEDULE = [
  { time: "06:00", show: "Opgewekt!", host: "Ochtendteam" },
  { time: "09:00", show: "All-In Non-stop", host: "Automatisch" },
  { time: "12:00", show: "Lunchroom Classics", host: "Automatisch" },
  { time: "16:00", show: "Drivetime", host: "Middagteam" },
  { time: "20:00", show: "Avondprogramma", host: "Wisselend" },
  { time: "00:00", show: "Nachtmuziek", host: "Automatisch" },
];

export const HISTORY = {
  intro:
    "All-In Radio ontstond uit een simpele passie: mensen samenbrengen met muziek. Wat begon als een klein initiatief groeide uit tot een station dat 24/7 de beste hits laat horen.",
  milestones: [
    { year: "2018", title: "De eerste uitzending", text: "Vanuit een kleine thuisstudio ging All-In Radio voor het eerst de lucht in." },
    { year: "2020", title: "Online 24/7", text: "De livestream werd non-stop beschikbaar via internet voor luisteraars overal." },
    { year: "2022", title: "Nieuwe programma's", text: "Vaste programma's zoals 'De Muziekmarathon!' en 'ALL-12-inch!' werden geïntroduceerd." },
    { year: "2024", title: "Volledig vernieuwd", text: "Een frisse studio, nieuwe stem en een groeiende community van luisteraars." },
  ],
};

export const LISTEN_LINKS = [
  { id: "web", name: "Web player", desc: "Luister direct hier op de site", icon: "PlayCircle", href: "https://media2.hostin.cc/allinradio.mp3" },
  { id: "tunein", name: "TuneIn", desc: "Beluister via de TuneIn app", icon: "Headphones", href: "https://tunein.com/radio/AllIn-Radio-s340828/" },
  { id: "apple", name: "AAC stream", desc: "AAC-stream voor Apple-apparaten", icon: "AudioLines", href: "https://media2.hostin.cc/allinradio.aac" },
  { id: "android", name: "MyTuner", desc: "Luister via de MyTuner app", icon: "Smartphone", href: "https://mytuner-radio.com/radio/all-in-radio-509718/" },
  { id: "smart", name: "AllRadio", desc: "Speel af via je slimme speaker", icon: "Speaker", href: "https://www.allradio.nl/#All-In+Radio" },
  { id: "stream", name: "Radio Nederland", desc: "Directe stream via Radio Nederland", icon: "Radio", href: "https://www.radio-nederland.nl/all-in-radio" },
  { id: "onlineradiobox", name: "Online Radio Box", desc: "Beluister via Online Radio Box", icon: "RadioTower", href: "https://onlineradiobox.com/nl/allin/" },
  { id: "playdio", name: "Playdio", desc: "Luister via Playdio.radio", icon: "Music", href: "https://playdio.radio/netherlands/allinradio-ra4466/" },
  { id: "nlradionet", name: "NL.Radio.Net", desc: "Luister via NL.Radio.Net", icon: "Globe", href: "https://nl.radio.net/s/allinradio" },
  { id: "radioguide", name: "RadioGuide", desc: "Luister via RadioGuide.fm", icon: "Compass", href: "https://www.radioguide.fm/internet-radio-nederland/all-in-radio" },
];

export const SOCIALS = [
  { id: "instagram", name: "Instagram", href: "https://www.instagram.com/allinradionl/", icon: "Instagram" },
  { id: "facebook", name: "Facebook", href: "https://www.facebook.com/allinradionl/", icon: "Facebook" },
];
